import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

export function createModalPortal(reactNode: ReactNode) {
  return createPortal(reactNode, document.querySelector('#modal-portal'))
}
